// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { CITY } from '../../../common/constant'
import { post } from '../../api'

export const actionCity = createAsyncThunk('appCity/actionCity', async (params, thunkAPI) => {
    return await post(CITY, params, thunkAPI)
})

export const appCitySlice = createSlice({
    name: 'appCity',
    initialState: {
        //list
        loading: false,
        city: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetCityResponse: (state) => {
            state.city = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionCity.pending, (state) => {
                state.loading = true
            })
            .addCase(actionCity.fulfilled, (state, action) => {
                state.loading = false
                state.city = action.payload
            })
            .addCase(actionCity.rejected, (state) => {
                state.loading = false
            })
    }
})
export const { resetCityResponse } = appCitySlice.actions

export default appCitySlice.reducer